module.exports = __webpack_public_path__ + "static/media/home_white_logo.f0a71d24.png";